import { Link } from 'react-router-dom';
import { Instagram, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#2D2B2A] text-[#F9F6F0]" data-testid="main-footer">
      {/* Footer Content */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand & Description */}
          <div>
            <h3 className="font-heading text-2xl mb-4">BLR NAIL CLUB</h3>
            <p className="text-[#F9F6F0]/60 font-light text-sm leading-relaxed">
              Bengaluru's premier nail and beauty studio. Where luxury meets precision, 
              and every visit is an experience in elegance.
            </p>
            <a
              href="https://www.instagram.com/blr_nailclub/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 text-[#F9F6F0]/80 hover:text-[#B8860B] transition-colors text-sm mt-4"
              data-testid="footer-instagram-link"
            >
              <Instagram strokeWidth={1} size={18} />
              <span>@blr_nailclub</span>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#B8860B] text-xs tracking-[0.2em] uppercase mb-6">Quick Links</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-[#F9F6F0]/80 hover:text-[#B8860B] transition-colors text-sm">
                Home
              </Link>
              <Link to="/services" className="text-[#F9F6F0]/80 hover:text-[#B8860B] transition-colors text-sm">
                Services
              </Link>
              <Link to="/gallery" className="text-[#F9F6F0]/80 hover:text-[#B8860B] transition-colors text-sm">
                Gallery
              </Link>
              <Link to="/blog" className="text-[#F9F6F0]/80 hover:text-[#B8860B] transition-colors text-sm">
                Blog
              </Link>
              <Link to="/about" className="text-[#F9F6F0]/80 hover:text-[#B8860B] transition-colors text-sm">
                About Us
              </Link>
              <Link to="/contact" className="text-[#F9F6F0]/80 hover:text-[#B8860B] transition-colors text-sm">
                Contact
              </Link>
            </div>
          </div>

          {/* Our Branches */}
          <div>
            <h4 className="text-[#B8860B] text-xs tracking-[0.2em] uppercase mb-6">Our Branches</h4>
            <div className="flex flex-col gap-3">
              <Link to="/nails-rr-nagar" className="text-[#F9F6F0]/80 hover:text-[#B8860B] transition-colors text-sm">
                BLR Nail Club - RR Nagar
              </Link>
              <Link to="/nailashes-basaveshwarnagar" className="text-[#F9F6F0]/80 hover:text-[#B8860B] transition-colors text-sm">
                Nailashes - Basaveshwarnagar
              </Link>
              <Link to="/nails-sahakarnagar" className="text-[#F9F6F0]/80 hover:text-[#B8860B] transition-colors text-sm flex items-center gap-2">
                BLR Nail Club - Sahakarnagar <span className="text-[#B8860B] text-[10px]">NEW</span>
              </Link>
              <Link to="/nails-gunjur" className="text-[#F9F6F0]/80 hover:text-[#B8860B] transition-colors text-sm">
                BLR Nail Club - CSK Mall Gunjur
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-[#B8860B] text-xs tracking-[0.2em] uppercase mb-6">Contact</h4>
            <div className="flex flex-col gap-4">
              <a
                href="tel:+917204602211"
                className="flex items-start gap-3 text-[#F9F6F0]/80 hover:text-[#B8860B] transition-colors text-sm"
                data-testid="footer-phone-link"
              >
                <Phone strokeWidth={1} size={18} className="mt-0.5 flex-shrink-0" />
                <span>+91 72046 02211 (RR Nagar)</span>
              </a>
              <a
                href="tel:+917204604503"
                className="flex items-start gap-3 text-[#F9F6F0]/80 hover:text-[#B8860B] transition-colors text-sm"
              >
                <Phone strokeWidth={1} size={18} className="mt-0.5 flex-shrink-0" />
                <span>+91 72046 04503 (Sahakarnagar)</span>
              </a>
              <a
                href="tel:+919741763377"
                className="flex items-start gap-3 text-[#F9F6F0]/80 hover:text-[#B8860B] transition-colors text-sm"
              >
                <Phone strokeWidth={1} size={18} className="mt-0.5 flex-shrink-0" />
                <span>+91 97417 63377 (CSK Mall)</span>
              </a>
              <a
                href="tel:+919611560759"
                className="flex items-start gap-3 text-[#F9F6F0]/80 hover:text-[#B8860B] transition-colors text-sm"
              >
                <Phone strokeWidth={1} size={18} className="mt-0.5 flex-shrink-0" />
                <span>+91 96115 60759 (Basaveshwarnagar)</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#F9F6F0]/10 py-6">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#F9F6F0]/40 text-xs">
            © {new Date().getFullYear()} BLR Nail Club. All rights reserved.
          </p>
          <p className="text-[#F9F6F0]/40 text-xs">
            Premium Nail & Beauty Studio
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
